import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { activateUserSession } from '../utils/sessionActivity';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          navigate('/auth');
          return;
        }

        // Check if user was signing up as investor
        const accountType = localStorage.getItem('google_auth_type') || 'customer';
        localStorage.removeItem('google_auth_type');

        // Exchange session_id with backend, passing account type
        const response = await axios.post(`${API}/auth/google/session`, {
          session_id: sessionId,
          account_type: accountType
        }, { withCredentials: true });

        if (response.data.success) {
          const user = response.data.user;
          const userType = response.data.user_type || accountType;

          if (userType === 'investor') {
            localStorage.setItem('investor_data', JSON.stringify(user));
            activateUserSession();
            window.history.replaceState(null, '', window.location.pathname);
            navigate('/investor/dashboard', { state: { user }, replace: true });
          } else {
            localStorage.setItem('user_data', JSON.stringify(user));
            activateUserSession();
            window.history.replaceState(null, '', window.location.pathname);
            navigate('/account', { state: { user }, replace: true });
          }
        } else {
          navigate('/auth');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/auth');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-green-600 mx-auto" />
        <p className="mt-3 text-gray-600">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
